import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Row, Col, Badge } from 'reactstrap';
import RoomListItemActions from './RoomListItemActions';
import { ROOMS, NO_AVAILABILITY } from 'utils/constants';

class HostBookingRoomListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showRoomDetailsModal: false,
      showRoomADAccessibleModal: false,
      selectedRoom: null,
      previousPagePosition: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { page } = props;
    const { showRoomDetailsModal, previousPagePosition } = state;

    return {
      previousPagePosition: showRoomDetailsModal ? previousPagePosition : page
    };
  }

  toggleADAccessibleRoomModal = () => {
    const { showRoomADAccessibleModal } = this.state;

    this.setState({
      showRoomADAccessibleModal: !showRoomADAccessibleModal
    });
  };

  render() {
    const {
      room,
      rewards,
      subTotal,
      originalSubtotal,
      property,
      onSelect,
      index,
      isWaitListBooking,
      waitListBookingReason
    } = this.props;

    const nightlyAverage =
      subTotal / room.minRoomRate.expectedCharges.chargesForPostingDate.length;
    const originalNightlyAverage = originalSubtotal
      ? originalSubtotal /
        room.rackRoomRate.expectedCharges.chargesForPostingDate.length
      : null;

    const roomInfo = ROOMS[property][room.roomType.roomTypeCodes.roomTypeCode];

    if (!roomInfo) {
      return null;
    }

    const waitlistComp = waitListBookingReason?.value === 'COMP';

    return (
      <React.Fragment>
        <Row>
          <Col xs={12} sm={6} className="room-details">
            <h4>{room.roomType.roomTypeDescription || roomInfo.name}</h4>
          </Col>
          <Col xs={12} sm={3} className="actions subtotal">
            <RoomListItemActions
              room={room}
              subTotal={subTotal}
              originalSubtotal={originalSubtotal}
              nightlyAverage={nightlyAverage}
              originalNightlyAverage={originalNightlyAverage}
              waitlistComp={waitlistComp}
              rewards={rewards}
              onSelect={onSelect}
              isWaitListBooking={isWaitListBooking}
              index={index}
            />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

HostBookingRoomListItem.propTypes = {
  room: PropTypes.object,
  subTotal: PropTypes.number,
  originalSubtotal: PropTypes.number,
  property: PropTypes.string,
  rewards: PropTypes.array,
  onSelect: PropTypes.func,
  index: PropTypes.number,
  isWaitListBooking: PropTypes.bool,
  waitListBookingReason: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })
};

export default HostBookingRoomListItem;
